import { CSSObject } from '@mantine/core'
import { MantineThemeComponents } from '@mantine/styles/lib/theme/types/MantineTheme'
import { getInputStyles } from 'plugin-mantine-resources/src/helpers/inputHelpers'

export const Input: MantineThemeComponents['Input'] = {
    styles: (__, _, runtimeProps): Record<string, CSSObject> => {
        return getInputStyles(runtimeProps)
    }
}
